import { render, staticRenderFns } from "./LeccionA1.vue?vue&type=template&id=f4b08a4e&"
import script from "./LeccionA1.vue?vue&type=script&lang=js&"
export * from "./LeccionA1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports